export const INFO_CARD_BORDER_COLOR = "#EBF5FD";
